import React from 'react';
import { RadioButtonChecked } from '@material-ui/icons';
import FormConfigLayoutGrid from '../../config/FormConfigLayoutGrid';
import FormConfigRadioGroup from '../../config/FormConfigRadioGroup';
import { FormRadioGroup } from '../../fields/FormRadioGroup';
export const FormRadioGroupPlugin = {
    icon: React.createElement(RadioButtonChecked, null),
    name: 'Multiple choice',
    type: 'RadioGroup',
    dataTypes: ['text', 'integer', 'numeric', 'enum'],
    configurator: FormConfigRadioGroup,
    layoutConfigurator: () => React.createElement(FormConfigLayoutGrid, null),
    element: FormRadioGroup
};
//# sourceMappingURL=FormRadioGroupPlugin.js.map